import {Pipe,PipeTransform} from '@angular/core';

@Pipe({
    name:'MinMaxValueConvertionPipe',
    pure:true
})

export class MinMaxValueConvertionPipe implements PipeTransform {
    transform(minMaxValue:string):any{
		let tmpValue = minMaxValue.toString().split(".");
		if(tmpValue.length > 1){
			if(tmpValue[1] == "0"){						
				return Number(minMaxValue);						
			}else{
				return minMaxValue;
			}
		}else{
			if(Number(minMaxValue) == 257|| Number(minMaxValue) == 7200){
				var minutesMinMaxVal = Number(minMaxValue)/60;
				var secondsMinMaxVal = Number(minMaxValue)%60;
				return minutesMinMaxVal+":"+(secondsMinMaxVal < 9?"0"+secondsMinMaxVal:secondsMinMaxVal);
			}else{
				return minMaxValue;
			}					
		}
    }
}